<template>
  <div class="mt-5">
    <v-row align="center" justify="center" dense>
      <v-col cols="12" md="10">
        <v-data-table
          :search="search"
          :headers="headers"
          :items="items"
          sort-by="code"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Parcelle</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Rechercher"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Ajouter
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.Code"
                            label="Code"
                            :disabled="DisableCode"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.Désignation"
                            label="Désignation"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-select
                            v-model="editedItem.Ferme"
                            :items="Farm_List"
                            label="Ferme"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-select
                            v-model="editedItem.Variété"
                            :items="Variété_list"
                            label="Variété"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      Annuler
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                      Enregistrer
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5"
                    >Êtes-vous sûr de supprimer cet élément?</v-card-title
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete"
                      >Annuler</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                      >OK</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize"> Actualiser </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import firebaseApp from "../../firebase";
import { mapState } from "vuex";
export default {
  data: () => ({
    search: "",
    items: [],
    typeVéhicule: ["PickUp", "MiniBus"],
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Code", align: "start", value: "Code" },
      { text: "Désignation", value: "Désignation" },
      { text: "Ferme", value: "Ferme" },
      { text: "Variété", value: "Variété" },
      { text: "Actions", value: "action", sortable: false },
    ],

    editedIndex: -1,
    editedItem: {
      id: null,
      Code: null,
      Désignation: null,
      Ferme: null,
      Variété: null,
    },
    defaultItem: {
      id: null,
      Code: null,
      Désignation: null,
      Ferme: null,
      Variété: null,
    },
  }),

  computed: {
    ...mapState(["Farm_List", "Variété_list"]),

    formTitle() {
      return this.editedIndex === -1 ? "Ajouter" : "Editer";
    },
    DisableCode() {
      return this.editedIndex === -1 ? false : true;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  mounted() {
    this.initialize();
    this.$store.dispatch("get_Fermes");
    this.$store.dispatch("get_Variété");
  },

  methods: {
    initialize() {
      firebaseApp
        .ref("Parcelle")
        .once("value")
        .then((snapshot) => {
          this.items = [];
          snapshot.forEach((doc) => {
            const item = doc.val();
            this.items.push({
              id: doc.key,
              Code: item["Code"],
              Désignation: item["Désignation"],
              Ferme: item["Ferme"],
              Variété: item["Variété"],
            });
          });
        });
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.items.splice(this.editedIndex, 1);
      firebaseApp.ref(`Parcelle/${this.editedItem.id}`).remove();
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem);
        var updates = {};
        updates[`Parcelle/${this.editedItem.id}`] = this.editedItem;
        firebaseApp.ref().update(updates);
      } else {
        this.items.push(this.editedItem);
        console.log(this.editedItem);
        var newitemId = firebaseApp.ref().child("Parcelle").push().key;
        this.editedItem.id = newitemId;
        firebaseApp.ref(`Parcelle/${this.editedItem.id}`).set(this.editedItem);
      }
      this.close();
    },
  },
};
</script>
